// src/modules/maintenance/utils/maintenanceUtils.js
// Periyodik bakım yardımcı fonksiyonları

import React from 'react';
import { Chip } from '@mui/material';

/**
 * Timestamp'i Türkçe tarih formatına çevirir
 * @param {Timestamp|Date} timestamp 
 * @returns {string}
 */
export const formatDate = (timestamp) => {
    if (!timestamp) return '-';
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    return date.toLocaleDateString('tr-TR');
};

/**
 * Bakıma kaç gün kaldığını hesaplar
 * @param {Timestamp|Date} timestamp 
 * @returns {number|null}
 */
export const getDaysUntilMaintenance = (timestamp) => {
    if (!timestamp) return null;
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    date.setHours(0, 0, 0, 0);
    const diffTime = date - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
};

/**
 * Duruma göre renk kodlu Chip döndürür
 * @param {number|null} daysUntil 
 * @param {string} bakimDurumu 
 * @returns {JSX.Element}
 */
export const getStatusChip = (daysUntil, bakimDurumu) => {
    if (bakimDurumu === 'Bekleniyor') {
        return <Chip label="SMS Gönderildi - Bekleniyor" color="warning" size="small" />;
    }
    if (daysUntil === null) {
        return <Chip label="Tarih Belirlenmemiş" color="default" size="small" />;
    }
    if (daysUntil < 0) {
        return <Chip label={`${Math.abs(daysUntil)} gün geçti`} color="error" size="small" />;
    }
    if (daysUntil === 0) {
        return <Chip label="Bugün" color="error" size="small" />;
    }
    if (daysUntil <= 7) {
        return <Chip label={`${daysUntil} gün kaldı`} color="warning" size="small" />;
    }
    if (daysUntil <= 30) {
        return <Chip label={`${daysUntil} gün kaldı`} color="info" size="small" />;
    }
    return <Chip label={`${daysUntil} gün kaldı`} color="success" size="small" />;
};

/**
 * Sonraki bakım tarihini hesaplar
 * @param {number} suresi - Süre miktarı
 * @param {string} birimi - 'gün', 'hafta', 'ay'
 * @returns {Date}
 */
export const calculateNextMaintenanceDate = (suresi, birimi) => {
    const nextDate = new Date();

    if (birimi === 'ay') {
        nextDate.setMonth(nextDate.getMonth() + suresi);
    } else if (birimi === 'hafta') {
        nextDate.setDate(nextDate.getDate() + (suresi * 7));
    } else {
        nextDate.setDate(nextDate.getDate() + suresi);
    }

    return nextDate;
};
